<mat-card style="margin-left:30px;margin-top:50px;margin-right:30px">
    <mat-card-content>
        <div class="container-full mt-3">
        @if(displayMode === 0){

        
        <h4>Active Rate</h4>
        <button mat-button  (click)="onDisplayMode(1)">All</button>
        <hr />
            <div class="row" style="font-weight:bold;">
                <div class="col-2">
                       
                </div>
                <div class="col-1">
                    Rate Number
                </div>
                <div class="col-2">
                    Type
                </div>
                <div class="col-2">
                    Description
                </div>
                <div class="col-1">
                    Start Date
                </div>
                <div class="col-1">
                    End Date
                </div>
                <div class="col-1">
                    Amount
                </div>
                <div class="col-1">
                    Tax
                </div>
                <div class="col-1">
                    Portal
                </div>
            </div>

            <div class="row">
                <div class="col-2">
                    
                   
                </div>
                <div class="col-1">
                    35
                </div>
                <div class="col-2">
                    Reserved
                </div>
                <div class="col-2">
                    Unreserved Market Rate
                </div>
                <div class="col-1">
                    1/1/24
                </div>
                <div class="col-1">
                    12/31/24
                </div>
                <div class="col-1">
                    $100.00
                </div>
                <div class="col-1">
                    $0.00
                </div>
                <div class="col-1">
                    <mat-checkbox
                    class="example-margin"
                    [checked]="false" >
                  </mat-checkbox>
                </div>
            </div>

        }
            
            <hr />

            @if(displayMode == 1){
                <h4>Active, Expired and Future Rate</h4>
                <button mat-button (click)="onDisplayMode(0)">Active Rates Only</button>
                <hr />
                <div class="row" style="font-weight:bold;height:50px;">
                    <div class="col-2">
                        
                    </div>
                    <div class="col-1">
                        Rate Number
                    </div>
                    <div class="col-2">
                        Type
                    </div>
                    <div class="col-2">
                        Description
                    </div>
                    <div class="col-1">
                        Start Date
                    </div>
                    <div class="col-1">
                        End Date
                    </div>
                    <div class="col-1">
                        Amount
                    </div>
                    <div class="col-1">
                        Tax
                    </div>
                    <div class="col-1">
                        Portal
                    </div>
                </div>
    
                <div class="row" style="background-color:lightgray;color:black;;height:50px;">
                    <div class="col-2">
                       <span>FUTURE RATE</span>
                    </div>
                    <div class="col-1">
                        35
                    </div>
                    <div class="col-2">
                        Reserved
                    </div>
                    <div class="col-2">
                        Unreserved Market Rate
                    </div>
                    <div class="col-1">
                        1/1/25
                    </div>
                    <div class="col-1">
                        12/31/1999
                    </div>
                    <div class="col-1">
                        $120.00
                    </div>
                    <div class="col-1">
                        $0.00
                    </div>
                    <div class="col-1">
                        inherit portal?
                    </div>
                </div>

                <div class="row" style="background-color:green;color:white;height:50px;">
                    <div class="col-2">
                       <span style="color:white;">ACTIVE RATE</span>
                    </div>
                    <div class="col-1">
                        35
                    </div>
                    <div class="col-2">
                        Reserved
                    </div>
                    <div class="col-2">
                        Unreserved Market Rate
                    </div>
                    <div class="col-1">
                        1/1/24
                    </div>
                    <div class="col-1">
                        12/31/24
                    </div>
                    <div class="col-1">
                        $100.00
                    </div>
                    <div class="col-1">
                        $0.00
                    </div>
                    <div class="col-1">
                        <mat-checkbox
                        class="example-margin"
                        [checked]="false" >
                      </mat-checkbox>
                    </div>
                </div>

                <div class="row"  style="background-color:red;color:white;height:50px;">
                    <div class="col-2">
                        EXPIRED
                    </div>
                    <div class="col-1">
                        35
                    </div>
                    <div class="col-2">
                        Reserved
                    </div>
                    <div class="col-2">
                        Unreserved Market Rate
                    </div>
                    <div class="col-1">
                        1/1/23
                    </div>
                    <div class="col-1">
                        12/31/23
                    </div>
                    <div class="col-1">
                        $80.00
                    </div>
                    <div class="col-1">
                        $0.00
                    </div>
                    <div class="col-1">
                        ??
                    </div>
                </div>

                <div class="row"  style="background-color:red;color:white;height:50px;">
                    <div class="col-2">
                        EXPIRED
                    </div>
                    <div class="col-1">
                        35
                    </div>
                    <div class="col-2">
                        Reserved
                    </div>
                    <div class="col-2">
                        Unreserved Market Rate
                    </div>
                    <div class="col-1">
                        1/1/22
                    </div>
                    <div class="col-1">
                        12/31/22
                    </div>
                    <div class="col-1">
                        $70.00
                    </div>
                    <div class="col-1">
                        $0.00
                    </div>
                    <div class="col-1">
                        ??
                    </div>
                </div>

                <div class="row"  style="background-color:red;color:white;">
                    <div class="col-2">
                       EXPIRED
                    </div>
                    <div class="col-1">
                        35
                    </div>
                    <div class="col-2">
                        Reserved
                    </div>
                    <div class="col-2">
                        Unreserved Market Rate
                    </div>
                    <div class="col-1">
                        1/1/21
                    </div>
                    <div class="col-1">
                        12/31/21
                    </div>
                    <div class="col-1">
                        $60.00
                    </div>
                    <div class="col-1">
                        $0.00
                    </div>
                    <div class="col-1">
                       ??
                       </div>
                </div>
            }
        </div>


    </mat-card-content>
</mat-card>

